import React from "react";
import viewReportArrow from '../../../assets/home/view-report-arrow.svg'

const ViewReportLink = ({onClick}) => (
	<div className="widget-report-link" onClick={onClick}>
		View Report
		<img src={viewReportArrow} alt="" />
	</div>
);

export default ViewReportLink;